import React from 'react';
import '../style/footer.css';
import SocialIcons from './SocialIcons';

const Footer = () => {
  return (
    <footer className="footer">
      <SocialIcons />
      <div>
        <p>
          <span className="no-underline">Contact:</span>
          <span className="underline email">noahflood12@gmail.com</span>
        </p>
      </div>

      <p>&copy; 2025 Noah Flood. All rights reserved.</p>
    </footer>
  );
};

export default Footer;